<script setup lang="ts">
defineProps<{
  title: string;
  id?: string;
}>();

const emit = defineEmits<{
  (e: "click", event: Event): void;
}>();

function onClick(e: Event) {
  emit("click", e);
}
</script>

<template>
  <button
    type="button"
    :title="title"
    :id="id"
    @click="(e) => onClick(e)"
  >
    <slot />
  </button>
</template>

<style scoped lang="postcss">
button {
  @apply align-middle text-2xl;
}
</style>
